import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuthState } from "../hooks/useAuth";
import ExitButton from "./ExitButton";
import MySpaceButton from "./MySpaceButton";
import MyContentButton from "./MyContentButton";

const StudyButtons = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user } = useAuthState();

  if (user?.isActive === false) {
    return null;
  }

  const searchParams = new URLSearchParams(location.search);
  const lessonIdFromUrl = searchParams.get("lessonId");
  
  // Don't show StudyButtons on /study/notes with lessonId (uses NavigationButtons instead)
  if (location.pathname === "/study/notes" && lessonIdFromUrl) {
    return null;
  }

  const shouldShow =
    location.pathname.startsWith("/study/") ||
    location.pathname.startsWith("/view/") ||
    location.pathname === "/all-lessons";

  if (!shouldShow) return null;

  const folderFromUrl = searchParams.get("folder");
  const typeFromUrl = searchParams.get("type");
  const handleExit = () => {
    // Exit from all-lessons goes to myspace
    if (location.pathname === "/all-lessons") {
      navigate("/myspace");
      return;
    }
    if (location.pathname.startsWith("/view/lesson/")) {
      if (folderFromUrl) {
        navigate(`/study/lessons?folder=${encodeURIComponent(folderFromUrl)}`);
      } else {
        navigate("/study/lessons");
      }
    } else if (folderFromUrl) {
      const parts = folderFromUrl.split(" / ");
      if (parts.length > 1) {
        parts.pop();
        navigate(
          `/study/lessons?folder=${encodeURIComponent(parts.join(" / "))}`,
        );
      } else {
        navigate("/study/lessons");
      }
    } else {
      navigate("/myspace");
    }
  };

  return (
    <>
      <ExitButton onClick={handleExit} />
      <MySpaceButton folder={folderFromUrl} lessonId={lessonIdFromUrl} />
      <MyContentButton folder={folderFromUrl} type={typeFromUrl} />
    </>
  );
};

export default StudyButtons;
